import { ReactElement } from 'react';
import {
  Card,
  CardContent,
  Grid,
  Link,
  makeStyles,
  Typography,
} from '@material-ui/core';
import Chat from '@material-ui/icons/Chat';
import { FontFamily } from '@principal-developer-portal/ui';
import { ExceptionCardInfo } from './types/exception';

interface ModalExceptionCardProps {
  exceptionCardItems: ExceptionCardInfo[];
}

// eslint-disable-next-line max-lines-per-function
const useStyles = makeStyles(theme => ({
  card: {
    width: '100%',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.primary.main}`,
    gap: '16px',
    padding: '16px',
    flex: '0 1 auto',
    boxShadow: 'none',
  },
  heading: {
    width: 'auto',
    minHeight: '32px',
    whiteSpace: 'normal',
    overflow: 'visible',
    fontFamily: FontFamily.Bold,
    fontWeight: 400,
    paddingBottom: '24px',
    fontSize: '20px',
    lineHeight: '32px',
  },
  icon: {
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '18px',
    paddingTop: '4px',
    paddingBottom: '4px',
    color: '#1976d2',
  },
  title: {
    color: `${theme.palette.link}`,
    whiteSpace: 'normal',
    overflow: 'visible',
    fontFamily: FontFamily.Bold,
    fontWeight: 400,
    marginBottom: '4px',
    fontSize: '14px',
    wordBreak: 'break-word',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '&:focus': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  description: {
    fontFamily: FontFamily.Regular,
    fontSize: '14px',
    lineHeight: '24px',
    whiteSpace: 'normal',
    overflow: 'visible',
    wordBreak: 'break-word',
  },
  cardContent: {
    padding: '0px',
  },
}));

export const ModalExceptionCard = (
  props: ModalExceptionCardProps,
): ReactElement => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent key="modal-exception" className={classes.cardContent}>
        <Typography
          variant="h3"
          className={classes.heading}
          data-testid="Exception title"
        >
          Need an exception?
        </Typography>
        {props.exceptionCardItems?.map(exceptionItem => (
          <Grid
            container
            spacing={2}
            key={exceptionItem.name}
            alignItems="flex-start"
            style={{ paddingBottom: '16px' }}
          >
            <Grid item>
              <div
                className={classes.icon}
                data-testid={`${exceptionItem.name}-icon`}
              >
                <Chat />
              </div>
            </Grid>
            <Grid item xs>
              <Typography
                className={classes.title}
                data-testid={`${exceptionItem.name}-link`}
                title={exceptionItem.name}
              >
                <Link
                  href={exceptionItem.href}
                  className={classes.title}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {exceptionItem.name}{' '}
                </Link>
              </Typography>
              <Typography
                className={classes.description}
                data-testid={`${exceptionItem.name}-description`}
                title={exceptionItem.description}
                component="div"
              >
                {exceptionItem.description}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </CardContent>
    </Card>
  );
};
